import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Box, useMediaQuery } from "@mui/material";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { renderTextField } from "components/FormFields/FieldTypes";
import { OTPNormalizer } from "components/FormFields/normalizers";

const VerificationOTPField = (props) => {
  const { formValues } = props;
  const matches = useMediaQuery("(max-width:600px)");

  const refOne = useRef(null);
  const refTwo = useRef(null);
  const refThree = useRef(null);
  const refFour = useRef(null);
  const refFive = useRef(null);
  const refSix = useRef(null);

  useEffect(() => {
    if (formValues) {
      if (formValues.one && !formValues.two) {
        refTwo.current.focus();
      } else if (formValues.two && !formValues.three) {
        refThree.current.focus();
      } else if (formValues.three && !formValues.four) {
        refFour.current.focus();
      } else if (formValues.four && !formValues.five) {
        refFive.current.focus();
      } else if (formValues.five) {
        refSix.current.focus();
      }
    } else {
      refOne.current.focus();
    }
  }, [formValues]);

  return (
    <form>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box
          component="span"
          sx={{
            marginRight: matches ? 1 : 2,
            paddingLeft: {
              xs: "18px",
              sm: "18px",
              md: "23px",
              lg: "23px",
              xl: "23px",
            },
          }}
        >
          <Field
            name="one"
            width={matches ? "25px" : "40px"}
            label=""
            inputRef={refOne}
            component={renderTextField}
            normalize={OTPNormalizer}
            inputTextAlign="center"
          />
        </Box>
        <Box component="span" sx={{ marginRight: matches ? 1 : 2 }}>
          <Field
            name="two"
            label=""
            width={matches ? "25px" : "40px"}
            component={renderTextField}
            inputRef={refTwo}
            normalize={OTPNormalizer}
            inputTextAlign="center"
          />
        </Box>
        <Box component="span" sx={{ marginRight: matches ? 1 : 2 }}>
          <Field
            name="three"
            label=""
            width={matches ? "25px" : "40px"}
            inputRef={refThree}
            component={renderTextField}
            normalize={OTPNormalizer}
            inputTextAlign="center"
          />
        </Box>
        <Box component="span" sx={{ marginRight: matches ? 1 : 2 }}>
          <Field
            name="four"
            label=""
            width={matches ? "25px" : "40px"}
            inputRef={refFour}
            component={renderTextField}
            normalize={OTPNormalizer}
            inputTextAlign="center"
          />
        </Box>
        <Box component="span" sx={{ marginRight: matches ? 1 : 2 }}>
          <Field
            name="five"
            label=""
            width={matches ? "25px" : "40px"}
            inputRef={refFive}
            component={renderTextField}
            normalize={OTPNormalizer}
            inputTextAlign="center"
          />
        </Box>
        <Box component="span" sx={{ marginRight: 2, paddingRight: "24px" }}>
          <Field
            name="six"
            label=""
            width={matches ? "25px" : "40px"}
            inputRef={refSix}
            component={renderTextField}
            normalize={OTPNormalizer}
            inputTextAlign="center"
          />
        </Box>
      </Box>
    </form>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("OTP_FIELD")(state) || {},
    formValues: getFormValues("OTP_FIELD")(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(
  reduxForm({
    form: "OTP_FIELD",
  })(VerificationOTPField)
);
